import React from "react";
import { Button } from "@showitinc/showit-wc";

import UserActions from "@/actions/UserActions";
import { TRACK_SOURCE_PANEL } from "@/constants/AnalyticsConstants.mjs";
import { createFormFieldFromSelection } from "@/utils/PropertyUtils";

/**
 * Properties panel action that turns a selected legacy text form field into a modern input.
 * @param {Object} props
 * @param {Immutable.Map} props.selectedElements - The block's selected elements, by id.
 * @returns {JSX.Element}
 */
const ConvertToFormFieldButton = ({ selectedElements }) => (
  <Button
    data-testid="convert-to-form-field-panel-btn"
    fullWidth
    iconPrefix="formFieldText"
    iconSize="20"
    variant="minimal"
    onClick={() => {
      UserActions.trackPostHogEvent("convert_to_form_field_clicked", {
        source: TRACK_SOURCE_PANEL,
      });
      createFormFieldFromSelection(selectedElements, TRACK_SOURCE_PANEL);
    }}
  >
    Convert to Form Field
  </Button>
);

export default ConvertToFormFieldButton;
